interface DataTableSkeletonProps {
  columns: number;
  rows?: number;
}

function DataTableSkeleton({ columns, rows = 5 }: DataTableSkeletonProps) {
  return (
    <div className="rounded-xl border border-zt-border bg-zt-surface p-4">
      <div className="mb-3 flex gap-2">
        {Array.from({ length: columns }).map((_, i) => (
          <div
            key={`head-${i}`}
            className="h-4 flex-1 animate-pulse rounded bg-zt-border"
          />
        ))}
      </div>
      <div className="space-y-2">
        {Array.from({ length: rows }).map((_, row) => (
          <div key={`row-${row}`} className="flex gap-2">
            {Array.from({ length: columns }).map((_, col) => (
              <div
                key={`cell-${row}-${col}`}
                className="h-8 flex-1 animate-pulse rounded bg-zt-border"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default DataTableSkeleton;
